import { CONTACT_ITEMS } from "#pages/data";
import {
  Badge,
  Box,
  Container,
  Flex,
  Heading,
  Icon,
  Link,
  Stack,
  Text,
  useColorModeValue,
  VStack
} from "@chakra-ui/react";
import React from "react";
import { FaCheckCircle } from "react-icons/fa/index.js";
import LeadGen from "./LeadGen";

const TRUST_SIGNALS = [
  "Zero Carrier Bias Guarantee",
  "Quotes from 200+ Global Providers",
  "15+ Years of Engineering Experience",
];


const Contact = () => {
  const bgMain = useColorModeValue("gray.50", "gray.900");
  const textBody = useColorModeValue("gray.600", "gray.400");
  const headingColor = useColorModeValue("blue.900", "white");
  const contactLinkColor = useColorModeValue("blue.600", "blue.300");

  const whiteOrGrayBg = useColorModeValue("white", "gray.800");
  const whiteOrGrayBorderColor = useColorModeValue("gray.100", "gray.700");
  const blueBg = useColorModeValue("blue.50", "blue.900");

  return (
    <Box bg={bgMain} py={{ base: 12, md: 24 }} id="Contact">
      <Container maxW="container.xl">
        <Stack
          direction={{ base: "column", lg: "row" }}
          spacing={{ base: 10, lg: 20 }}
          align="flex-start"
        >
          {/* Left Side: Copy & Contact Methods */}
          <Box flex="1">
            <Badge colorScheme="green" mb={4} px={3} py={1} borderRadius="full">
              Ready to Scale?
            </Badge>
            <Heading as="h1" size="2xl" color={headingColor} mb={6} lineHeight="shorter">
              Let's Engineer Your Next Transition.
            </Heading>
            <Text fontSize="lg" color={textBody} mb={8}>
              Whether you're looking to eliminate bloated legacy telecom spend, secure your edge with active threat monitoring, or deploy enterprise UCaaS, we sit on your side of the table to negotiate the perfect contract.
            </Text>

            <VStack align="start" spacing={4} mb={10}>
              {TRUST_SIGNALS.map((signal, idx) => (
                <Flex key={idx} align="center">
                  <Icon as={FaCheckCircle} color="green.500" w={5} h={5} mr={3} />
                  <Text fontWeight="medium" color={headingColor}>{signal}</Text>
                </Flex>
              ))}
            </VStack>

            <Box borderTop="1px solid" borderColor={useColorModeValue("gray.200", "gray.700")} pt={8}>
              <Heading as="h3" size="md" mb={6} color={headingColor}>
                Direct Contact Methods
              </Heading>
              <Stack spacing={4}>
                {CONTACT_ITEMS.map(({ icon, data, hrefPrefix }, i) => (
                  <Link
                    href={`${hrefPrefix}${data}`}
                    key={i}
                    isExternal
                    _hover={{ textDecoration: "none" }}
                  >
                    <Flex
                      align="center"
                      p={4}
                      bg={whiteOrGrayBg}
                      borderRadius="xl"
                      boxShadow="sm"
                      border="1px solid"
                      borderColor={whiteOrGrayBorderColor}
                      transition="all 0.2s"
                      _hover={{ transform: "translateY(-2px)", boxShadow: "md", borderColor: "blue.500" }}
                    >
                      <Flex
                        w={12}
                        h={12}
                        bg={blueBg}
                        color="blue.500"
                        borderRadius="full"
                        align="center"
                        justify="center"
                        mr={4}
                      >
                        <Icon as={icon} w={5} h={5} />
                      </Flex>
                      <Text fontWeight="bold" color={contactLinkColor} fontSize="lg">
                        {data}
                      </Text>
                    </Flex>
                  </Link>
                ))}
              </Stack>
            </Box>
          </Box>

          {/* Right Side: Lead Gen Wizard */}
          <Box flex="1" w="full" maxW={{ base: "full", lg: "500px" }}>
            <LeadGen />
          </Box>
        </Stack>
      </Container>
    </Box>
  );
};

export default Contact;
